module.exports = __webpack_public_path__ + "static/media/Pedidos2.01423922.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancPedidos/Pedidos2.png
// module id = 1780
// module chunks = 0